var _path;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
class IconCommonsLine extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return _jsx(SVGIcon, {
      ...this.props,
      name: "IconCommons",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef,
      children: _path || (_path = _jsx("path", {
        d: "M715.926 1409.203c-250.128 0-453.094-201.777-453.094-449.644 0-247.602 204.487-449.643 454.882-449.643h272.823V352.175H715.926c-336.47 0-610.751 272.328-610.751 607.384 0 335.054 274.282 607.385 610.75 607.385H988.75v-157.741H715.926ZM368.007 959.559c0 189.642 155.74 344.469 347.919 344.469h377.998v368.09H715.926C321.538 1672.118 0 1352.868 0 959.56 0 566.248 321.537 247 715.926 247h379.786v368.09H717.714c-192.59 0-349.707 155.239-349.707 344.47Zm990.537-355.563v250.76H742.745c-58.564 0-104.754 46.204-104.754 104.803s46.19 104.803 104.754 104.803h615.8v250.76l402.577-355.563-402.578-355.563ZM1253.37 370.78 1920 959.56l-666.63 588.779v-378.802H742.744c-116.658 0-209.929-93.3-209.929-209.978 0-116.678 93.271-209.978 209.93-209.978h510.623V370.78Z"
      }))
    });
  }
}
IconCommonsLine.glyphName = 'commons';
IconCommonsLine.variant = 'Line';
IconCommonsLine.displayName = 'IconCommonsLine';
// eslint-disable-next-line react/forbid-foreign-prop-types
IconCommonsLine.propTypes = {
  ...SVGIcon.propTypes
};
IconCommonsLine.allowedProps = [...SVGIcon.allowedProps];
export default IconCommonsLine;
export { IconCommonsLine };